/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminAdminRouteImport } from './routes/_admin/admin'
import { Route as AdminEnvRouteImport } from './routes/_admin/env'
import { Route as AdminJobsRouteImport } from './routes/_admin/jobs'
import { Route as AdminUsersRouteImport } from './routes/_admin/users'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminRoute = AdminAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEnvRoute = AdminEnvRouteImport.update({
  id: '/env',
  path: '/env',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AdminAdminRoute
  '/env': typeof AdminEnvRoute
  '/jobs': typeof AdminJobsRoute
  '/users': typeof AdminUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AdminAdminRoute
  '/env': typeof AdminEnvRoute
  '/jobs': typeof AdminJobsRoute
  '/users': typeof AdminUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_admin/admin': typeof AdminAdminRoute
  '/_admin/env': typeof AdminEnvRoute
  '/_admin/jobs': typeof AdminJobsRoute
  '/_admin/users': typeof AdminUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/privacy' | '/terms' | '/admin' | '/env' | '/jobs' | '/users'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/privacy' | '/terms' | '/admin' | '/env' | '/jobs' | '/users'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/privacy'
    | '/terms'
    | '/_admin/admin'
    | '/_admin/env'
    | '/_admin/jobs'
    | '/_admin/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin': {
      id: '/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAdminRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/env': {
      id: '/_admin/env'
      path: '/env'
      fullPath: '/env'
      preLoaderRoute: typeof AdminEnvRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jobs': {
      id: '/_admin/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users': {
      id: '/_admin/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdminRoute: typeof AdminAdminRoute
  AdminEnvRoute: typeof AdminEnvRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminRoute: AdminAdminRoute,
  AdminEnvRoute: AdminEnvRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
